import React, { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const LanguageToggle: React.FC = () => {
  const { language, setLanguage } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);

  const languages = [
    { code: 'en', name: 'English', display: 'EN' },
    { code: 'ar', name: 'العربية', display: 'ع' },
    { code: 'tl', name: 'Tagalog', display: 'TL' },
    { code: 'hi', name: 'हिन्दी', display: 'हि' },
    { code: 'bn', name: 'বাংলা', display: 'বং' },
  ];

  const currentLanguage = languages.find(lang => lang.code === language);

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-8 h-8 sm:w-10 sm:h-10 rounded-full border-2 border-gray-300 hover:border-[#008B8B] flex items-center justify-center text-xs sm:text-sm font-medium transition-all hover:scale-105 bg-white"
        aria-label="Select language"
      >
        {currentLanguage?.display}
      </button>

      {isOpen && (
        <div className="absolute top-full mt-2 right-0 bg-white border border-gray-200 rounded-lg shadow-lg py-2 z-50 min-w-[120px]">
          {languages.map((lang) => (
            <button
              key={lang.code}
              onClick={() => {
                setLanguage(lang.code as any);
                setIsOpen(false);
              }}
              className={`w-full text-left px-4 py-2 hover:bg-gray-50 ${
                language === lang.code ? 'bg-[#008B8B] text-white' : 'text-gray-700'
              }`}
            >
              {lang.name}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageToggle;